// IRONYARD theme JS — Shopify Ajax Cart integration

function showToast(msg){
  var toast = document.getElementById('toast');
  if(!toast) return;
  toast.textContent = msg;
  toast.classList.add('show');
  clearTimeout(window._toastTimer);
  window._toastTimer = setTimeout(function(){ toast.classList.remove('show'); }, 2200);
}

var overlay, drawer;
function openDrawer(){ if(overlay && drawer){ overlay.classList.add('open'); drawer.classList.add('open'); } }
function closeDrawer(){ if(overlay && drawer){ overlay.classList.remove('open'); drawer.classList.remove('open'); } }

function formatMoney(cents){
  return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
}

function ironyardAddToCart(variantId, btnEl){
  if(!variantId) return;
  var body = new URLSearchParams();
  body.append('id', variantId);
  body.append('quantity', 1);
  fetch('/cart/add.js', {
    method: 'POST',
    body: body,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' }
  })
    .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function(item){
      refreshCart();
      showToast((item.product_title || 'Item') + ' added to cart');
      if(btnEl){
        var original = btnEl.textContent;
        btnEl.textContent = 'Loaded \u2713';
        btnEl.classList.add('added');
        setTimeout(function(){ btnEl.textContent = original; btnEl.classList.remove('added'); }, 1200);
      }
    })
    .catch(function(){ showToast('Could not add to cart'); });
}

function changeLine(key, quantity){
  fetch('/cart/change.js', {
    method: 'POST',
    body: JSON.stringify({ id: key, quantity: quantity }),
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
  })
    .then(function(r){ return r.json(); })
    .then(function(){ refreshCart(); })
    .catch(function(){ showToast('Could not update cart'); });
}

function refreshCart(){
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json(); })
    .then(renderCart)
    .catch(function(){});
}

function renderCart(cart){
  var badge = document.getElementById('cartBadge');
  if(badge) badge.textContent = cart.item_count;

  var body = document.getElementById('drawerBody');
  var foot = document.getElementById('drawerFoot');
  if(!body) return;

  if(cart.item_count === 0){
    body.innerHTML = '<div class="drawer-empty">Your cart is empty.<br>Go load something up.</div>';
    if(foot) foot.style.display = 'none';
    return;
  }

  body.innerHTML = cart.items.map(function(item){
    var img = item.image ? '<img src="' + item.image + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:4px;">' : '';
    return '' +
      '<div class="cart-item">' +
        '<div class="ci-icon">' + img + '</div>' +
        '<div class="ci-info">' +
          '<div class="ci-name">' + item.product_title + '</div>' +
          '<div class="ci-price mono">' + formatMoney(item.price) + '</div>' +
          '<div class="ci-controls">' +
            '<button class="qty-btn" type="button" onclick="changeLine(\'' + item.key + '\', ' + (item.quantity - 1) + ')">\u2212</button>' +
            '<span class="qty-val">' + item.quantity + '</span>' +
            '<button class="qty-btn" type="button" onclick="changeLine(\'' + item.key + '\', ' + (item.quantity + 1) + ')">+</button>' +
            '<button class="ci-remove" type="button" onclick="changeLine(\'' + item.key + '\', 0)">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }).join('');

  var subtotalEl = document.getElementById('subtotalVal');
  if(subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  if(foot) foot.style.display = 'block';
}

document.addEventListener('DOMContentLoaded', function(){
  overlay = document.getElementById('overlay');
  drawer = document.getElementById('drawer');

  var cartToggle = document.getElementById('cartToggle');
  var drawerClose = document.getElementById('drawerClose');
  if(cartToggle) cartToggle.addEventListener('click', openDrawer);
  if(drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if(overlay) overlay.addEventListener('click', closeDrawer);

  var menuToggle = document.getElementById('menuToggle');
  var navLinks = document.getElementById('navLinks');
  if(menuToggle && navLinks){
    menuToggle.addEventListener('click', function(){ navLinks.classList.toggle('open'); });
  }

  // Product page quantity stepper
  var pdQty = 1;
  var pdMinus = document.getElementById('pdMinus');
  var pdPlus = document.getElementById('pdPlus');
  var pdQtyVal = document.getElementById('pdQtyVal');
  var pdQtyInput = document.getElementById('pdQtyInput');
  if(pdMinus && pdPlus){
    pdMinus.addEventListener('click', function(){
      pdQty = Math.max(1, pdQty - 1);
      pdQtyVal.textContent = pdQty;
      if(pdQtyInput) pdQtyInput.value = pdQty;
    });
    pdPlus.addEventListener('click', function(){
      pdQty += 1;
      pdQtyVal.textContent = pdQty;
      if(pdQtyInput) pdQtyInput.value = pdQty;
    });
  }

  var pdForm = document.getElementById('pdForm');
  if(pdForm){
    pdForm.addEventListener('submit', function(e){
      e.preventDefault();
      var fd = new FormData(pdForm);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(item){
          refreshCart();
          openDrawer();
          showToast((item.product_title || 'Item') + ' added to cart');
        })
        .catch(function(){ showToast('Could not add to cart'); });
    });
  }

  refreshCart();
});
